export const ticketTypesDetailsStrings = {
  INTERNAL: "INTERNAL",
  EXTERNAL: "EXTERNAL"
};

export const pageObj = {
  pageName: "Create Ticket",
  betaPage: false
};

export const sourceOptions = [
  { key: "Phone", val: "PHONE" },
  { key: "Email", val: "EMAIL" }
];

export const assigneeTypes = {
  GROUP: "GROUP",
  USER: "USER",
  NONE: "NONE"
};

export const formKeys = {
  SOURCE: "source",
  ASSIGNEE: "assigneeName",
  CLIENT: "clientCode",
  ENTITY: "entityInput",
  MOBILE: "mobileNo",
  EMAIL: "email",
  NAME: "name",
  TYPE: "type",
  TITLE: "title",
  SUBJECT: "subject",
  BU: "buId",
  SEVERITY: "severity",
  GROUP_TYPE: "groupTypeId"
};

export const maxMobileNumberLength = 11;

export const minMobileNumberLength = 9;

export const maxCNOTELength = 10;

export const analyticsEventList = {
  render: {
    event_category: "createticket",
    event_action: "render",
    event_label: "Open Create Ticket"
  },
  requestor_search: {
    event_category: "createticket",
    event_action: "event",
    event_label: "Searching requestor details"
  },
  auto_assign_suggestion_used: {
    event_category: "createticket",
    event_action: "event",
    event_label: "Used auto assign suggestion"
  },
  ticket_created: {
    event_category: "createticket",
    event_action: "event",
    event_label: "Ticket creation success"
  }
};

export const primeGroupTypesList = [153, 159];

export const hideTicketTypeOptionsList = [
  "QC - CN Validation",
  "QC - CN Measurement",
  "Ewaybill Expiry",
  "Dispatch Hold - QC Mismatch",
  "RTO - forward and return cnote barcode scan",
  "NEFT knockoff",
  "Handover Pending WriteOff",
  "UTR NEFT Knock Off",
  "Pickup NEFT Knock Off"
];



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/createTicket/createTicketHelper.js